// Resolving an inventory item's category to its display pair — Category and Sub.
//
// 74s. This lives in one place because the derivation had been reimplemented in four
// pages and every copy carried the same silent bug, which is exactly how it survived
// long enough to reach production and be spotted from a screenshot rather than a test.
//
// The bug: every copy asked PostgREST for the parent with a self-referencing embed,
//
//     inventory_categories ( id, name, parent_id, inventory_categories ( id, name ) )
//
// and that resolves the self-referencing FK in the CHILD direction. It returns the row's
// children, which is an empty array for every leaf, and PostgREST answers 200 with no
// error. So `cat.inventory_categories?.name` was always undefined, every copy fell
// through to its no-parent branch, and the app printed the SUBcategory wherever the
// Category belonged. Verified against staging before the fix: Centrax came back as
// {"id":12,"name":"Centrax","parent_id":3,"inventory_categories":[]}.
//
// The fix is to resolve the parent from the flat category list each page already loads
// (or now loads) rather than from an embed. inventory_categories is a two-level
// hierarchy, so one lookup by parent_id is the whole job.
//
// Data model, settled with Colby at 74s: an item carries ONE category_id and it must
// point at a subcategory. Sub is that row; Category is its parent. There is no second
// column to keep in sync, and no item sits on a bare parent.

export function categoryLabel(cat, categories) {
  if (!cat) return { parent: null, sub: null };
  if (cat.parent_id) {
    const parent = (categories || []).find(c => c.id === cat.parent_id);
    return { parent: parent?.name || null, sub: cat.name };
  }
  // A row with no parent_id is itself a top-level category. Legacy items may still sit
  // here; they render as Category with no Sub rather than being hidden.
  return { parent: cat.name, sub: null };
}

// Single-line form — "Sheeted Materials · Coroplast" — for dense rows.
export function categoryLabelText(cat, categories, { fallback = '—' } = {}) {
  const { parent, sub } = categoryLabel(cat, categories);
  if (!parent && !sub) return fallback;
  if (!parent) return sub || fallback;
  return sub ? `${parent} · ${sub}` : parent;
}
